export const SITE_URL = "https://lifewestway.com";

/** Branded 1200x630 fallback share card used when a page has no hero image. */
export const DEFAULT_OG_IMAGE = `${SITE_URL}/og-default.jpg`;

/** Social crawlers require absolute URLs for og:image / twitter:image. */
export function toAbsoluteUrl(src?: string | null): string {
  if (!src) return DEFAULT_OG_IMAGE;
  if (/^https?:\/\//i.test(src)) return src;
  return `${SITE_URL}${src.startsWith("/") ? "" : "/"}${src}`;
}

type SocialImageOptions = {
  image?: string | null;
  alt?: string;
};

/**
 * Returns the og:image / twitter:image meta entries for a route head().
 * Always resolves to an absolute URL, falling back to the branded card.
 */
export function socialImageMeta({ image, alt }: SocialImageOptions = {}) {
  const url = toAbsoluteUrl(image);
  return [
    { property: "og:image", content: url },
    { property: "og:image:width", content: "1200" },
    { property: "og:image:height", content: "630" },
    { property: "og:image:alt", content: alt ?? "LifeWestWay — Global Expat Lifestyle & Career Hub" },
    { name: "twitter:card", content: "summary_large_image" },
    { name: "twitter:image", content: url },
    { name: "twitter:image:alt", content: alt ?? "LifeWestWay — Global Expat Lifestyle & Career Hub" },
  ];
}
